import { createSelector, OutputSelector } from 'reselect';
import { IOption } from '@alycecom/ui';

import { IRootState } from '../../../../store/root.types';

import { IFiltersState } from './filters.reducer';

const pathToFiltersState = (state: IRootState) => state.marketplace.filters;

export const getIsLoading = (
  filterType: keyof IFiltersState,
): OutputSelector<IRootState, boolean, (res: IFiltersState) => boolean> =>
  createSelector(pathToFiltersState, state => state[filterType].isLoading);

export const getIsLoaded = (
  filterType: keyof IFiltersState,
): OutputSelector<IRootState, boolean, (res: IFiltersState) => boolean> =>
  createSelector(pathToFiltersState, state => state[filterType].isLoaded);

export const getFilterItems = (
  filterType: keyof IFiltersState,
): OutputSelector<IRootState, IOption[], (res: IFiltersState) => IOption[]> =>
  createSelector(pathToFiltersState, state => state[filterType].items);
